import {
  className,
  getCookie,
  preparePriceRequest,
  getSelectedAddons,
  getSelectedFees,
  addAddon,
  addFee
} from '@shared/functions'
window.addEventListener( 'DOMContentLoaded', () => {
  const datePickerBlock = document.querySelector(`.${className}`)
  const messageBox = document.querySelector(`.wp-block-webdevia-rental-dates__message-box`)
  const addToCardBlock = document.querySelector('.wp-block-webdevia-rental-add-to-card')
  if (addToCardBlock ) {
    var qty = addToCardBlock.querySelector('.wp-block-webdevia-rental-add-to-card__quantity input')
    var rentForm = addToCardBlock.querySelector('form')
    var options = JSON.parse( addToCardBlock.dataset?.options )
  }

  let gSelectedDates

  if ( !!getCookie('rental_dates_cookie') ) {
    gSelectedDates = JSON.parse(getCookie('rental_dates_cookie'))
    addToCardBlock.querySelector('input[name="dates"]').value = getCookie('rental_dates_cookie')
  }

  if( rentForm ) {
    rentForm.addEventListener( 'submit', e => {
      if ( !!getCookie('rental_dates_cookie') ) {
        gSelectedDates = JSON.parse(getCookie('rental_dates_cookie'))
        addToCardBlock.querySelector('input[name="dates"]').value = getCookie('rental_dates_cookie')
      }
  
      const err = durationAndPrice.querySelector('.callout__error')
      if( !gSelectedDates || gSelectedDates.length == 0 || messageBox.innerHTML != '' || err ) {
        e.preventDefault()
        messageBox.innerHTML += `<br/>Please clear errors before submitting!`
        messageBox.style.display = 'block'
      } else {
        messageBox.innerHTML = ``
        messageBox.style.display = 'none'
      }
    } )
  }
  // @if type = 'pro'
  //----------- Addons
  if( !!datePickerBlock ) {
    const addons = datePickerBlock.querySelector('.list-addons')
    if ( addons ) {
      const addonsInput = addToCardBlock.querySelector('input[name=wd_addons]')
      let addonsRequest = false
      addons.querySelectorAll('.list-addons__addon input').forEach( addon => {
        if( addon.checked ) {
          addAddon( addon.value )
          addonsRequest = true
        }
      })
      if(addonsRequest) {
        addonsInput.value = JSON.stringify(getSelectedAddons())
      }
    }
  }

  //----------- Additional fees
  if( !!datePickerBlock ) {
    const fees = datePickerBlock.querySelector('.list-fees')
    if ( fees ) {
      const feesInput = addToCardBlock.querySelector('input[name=wd_fees]')
      let feesRequest = false
      fees.querySelectorAll('.list-fees__fee input').forEach( fee => {
        if( fee.checked ) {
          addFee( fee.value )
          feesRequest = true
        }
      })
      if(feesRequest) {
        feesInput.value = JSON.stringify(getSelectedFees())
      }
    }
  }
  // @endif
  if( qty ) {
    qty.addEventListener( 'change', e => {
      preparePriceRequest(options, e.target.value)
    })
  }
} )